import { CreditCard, MapPin } from "lucide-react";
import  { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReceiptText } from 'lucide-react';
import { Check } from 'lucide-react';
import { MoveRight } from 'lucide-react';
import { CloudLightning } from 'lucide-react';
import { getShadeNumberList } from "../../../redux/reduxApi/admin/ShadeReduxApi";
import { getMotorsList } from "../../../redux/reduxApi/admin/MotorizationReduxApi";
import { getProduct } from "../../../redux/reduxApi/admin/ProductReduxApi";
import Shoploader from "../loader/Shoploader";
import { toast } from "react-toastify";
import { getSalesOrderById } from "../../../redux/api/admin/SalesordersApi";
import { clearCartApi } from "../../../redux/api/website/Addtocartapi";
import { getCartProductsWebuser } from "../../../redux/reduxApi/website/CartProductCount";

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Get data from navigation state
  const { orderId, amount, selectedAddress } = location.state || {};
  console.log("OrderConfirmation received state:", { orderId, amount, selectedAddress });
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("Razorpay");

  // Data from Redux stores
  const [shadesData, setShadesData] = useState([]);
  const [motorData, setMotorData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [colorData, setColorData] = useState([]);

  // Get data from Redux
  const shadesFromRedux = useSelector((state) => state?.shades?.shades);
  const motorsFromRedux = useSelector((state) => state?.motors?.motors);
  const inventoryFromRedux = useSelector((state) => state?.inventory?.inventory);

  // Fetch master data if not available in Redux
  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        if (!shadesFromRedux || shadesFromRedux.length === 0) {
          const shadesRes = await dispatch(getShadeNumberList()).unwrap();
          setShadesData(shadesRes?.data?.shades || []);
          console.log("Fetched shades datasss:", shadesRes?.data?.shades);
          console.log("Fetched shades datasss:ss", shadesRes?.data?.shades);
        } else {
          setShadesData(shadesFromRedux);
          console.log("Shades from Redux:", shadesFromRedux);
        }

        if (!motorsFromRedux || motorsFromRedux.length === 0) {
          const motorsRes = await dispatch(getMotorsList()).unwrap();
          setMotorData(motorsRes?.data?.motors || []);
        } else {
          setMotorData(motorsFromRedux);
        }

        if (!inventoryFromRedux || inventoryFromRedux.length === 0) {
          const inventoryRes = await dispatch(getProduct({ page: 1, limit: 300 })).unwrap();
          setInventoryData(inventoryRes?.data?.products || []);
        } else {
          setInventoryData(inventoryFromRedux);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
      }
    };

    fetchMasterData();
  }, [dispatch, shadesFromRedux, motorsFromRedux, inventoryFromRedux]);

  const clearCart = async () => {
    try {
      const raw = sessionStorage.getItem("cartRowIds");
      const cartRowIds = raw ? JSON.parse(raw) : [];

      console.log("CLEARING CART IDS:", cartRowIds);

      if (!cartRowIds || cartRowIds.length === 0) {
        console.warn("No cart items found to clear");
        return;
      }

      await dispatch(clearCartApi(cartRowIds)).unwrap();
      await dispatch(getCartProductsWebuser());
      sessionStorage.removeItem("cartRowIds");

    } catch (err) {
      console.error("Cart clear failed after payment:", err);
    }
  };

  useEffect(() => {
    clearCart();
  }, []);

  // Fetch order details on component mount
  useEffect(() => {
    if (orderId) {
      fetchOrderDetails();
    } else {
      toast.error("Order ID not found");
      setLoading(false);
    }
  }, [orderId]);

  const fetchOrderDetails = async () => {
    setLoading(true);
    try {
      const response = await getSalesOrderById(orderId);
      if (response?.status === 200 && response?.data) {
        setOrderData(response.data.data.salesOrder);
        setOrderItems(response.data.data.items || []);

        // Clear session storage if needed
        sessionStorage.removeItem('currentOrderId');
        sessionStorage.removeItem('orderAmount');
      } else {
        toast.error("Failed to fetch order details");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      toast.error("Error loading order details");
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Get shade image by shade ID
  const getShadeImage = (shadeId) => {
    if (!shadesData || shadesData.length === 0 || !shadeId) {
      console.log("No shades data or shadeId:", { shadesData, shadeId });
      return "/fallback-image.jpg";
    }

    // Find shade by ID (ROWID or shadeNo)
    const shade = shadesData.find(item =>
      item.ROWID === shadeId || item.shadeNo === shadeId
    );

    console.log("Found shade:", shade, "for shadeId:", shadeId);

    if (shade && shade.shadeMedia && shade.shadeMedia.length > 0) {
      // If shadeMedia is an array of objects with URL
      if (typeof shade.shadeMedia[0] === 'object' && shade.shadeMedia[0].url) {
        return shade.shadeMedia[0].url;
      }
      // If shadeMedia is an array of strings (URLs)
      else if (typeof shade.shadeMedia[0] === 'string') {
        return shade.shadeMedia[0];
      }
    }

    return "/fallback-image.jpg";
  };

  // Get shade name/number by ID
  const getShadeNumber = (shadeId) => {
    if (!shadesData || shadesData.length === 0 || !shadeId) {
      return shadeId || "N/A";
    }

    const shade = shadesData.find(item =>
      item.ROWID === shadeId || item.shadeNo === shadeId
    );

    return shade?.shadeNo || shade?.name || shadeId;
  };

  // Get mechanism color name
  const getMechanismColorName = (colorId) => {
    if (!colorId || !colorData || colorData.length === 0) {
      return colorId || "Standard";
    }

    const color = colorData.find(c => c.ROWID === colorId);
    return color?.colorName || color?.name || colorId;
  };

  // Get motor name by ID
  const getMotorName = (motorId) => {
    if (!motorId || motorId === "N/A" || !motorData || motorData.length === 0) {
      return "No Motor";
    }

    const motor = motorData.find(m => m.ROWID === motorId);
    return motor?.motorName || motorId;
  };

  // Get product description by ID
  const getProductDescription = (productId) => {
    if (!productId || !inventoryData || inventoryData.length === 0) {
      return "Product";
    }

    const product = inventoryData.find(p => p.ROWID === productId);
    return product?.itemName || product?.productName || "Product";
  };

  // Format full address
  const formatFullAddress = (address) => {
    if (!address) return "Address not available";

    const parts = [];
    if (address.name) parts.push(address.name);
    if (address.address) parts.push(address.address);
    if (address.apartment) parts.push(`Apt: ${address.apartment}`);
    if (address.city) parts.push(address.city);
    if (address.state) parts.push(address.state);
    if (address.postalCode) parts.push(address.postalCode);
    if (address.country) parts.push(address.country);

    return parts.join(', ');
  };

  if (loading) {
    return (
      <div className="bg-[#FCFAF8] dark:bg-background-dark text-text-main dark:text-gray-100 min-h-screen flex items-center justify-center">
        <Shoploader />
      </div>
    );
  }

  // If no orderId or orderData, show error state
  if (!orderId || !orderData) {
    return (
      <div className="bg-[#FCFAF8] dark:bg-background-dark text-text-main dark:text-gray-100 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Order Not Found</h2>
          <p className="text-text-muted mb-6">We couldn't find the order you're looking for.</p>
          <button
            className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            onClick={() => navigate('/shop')}
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#FCFAF8] dark:bg-background-dark text-text-main dark:text-gray-100 min-h-screen flex flex-col font-display selection:bg-gray-300 selection:text-black">
      {/* Main Content */}
      <main className="flex-grow w-full max-w-[1200px] mx-auto px-4 sm:px-8 py-8 md:py-12 ">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 ">
          {/* Left Column: Success Message & Details */}
          <div className="lg:col-span-7 flex flex-col gap-6">
            {/* Hero Success Section */}
            <div className="flex flex-col items-start gap-2 p-3 bg-white dark:bg-surface-dark rounded-3xl shadow-sm border border-border-color dark:border-stone-700 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-forest-green/5 dark:bg-primary/10 rounded-bl-full -mr-8 -mt-8"></div>
              <div className="flex items-center gap-3 z-10">
                <div className="size-14 rounded-full bg-forest-green/10 dark:bg-primary/20 flex items-center justify-center text-forest-green dark:text-primary">
                </div>
                <div className="flex flex-col">
                  <h1 className="text-2xl sm:text-3xl font-bold text-text-main dark:text-white tracking-tight flex items-center gap-2">
                    <Check className="-ml-4" size={28} />
                    Thank you for your order!
                  </h1>

                  <p className="text-text-muted text-sm sm:text-base dark:text-stone-400 mt-0.5 ml-5">
                    Your custom blinds are being crafted with care.
                  </p>

                  <div className="w-[120%] -ml-[5%] h-px bg-black dark:bg-white my-2"></div>
                </div>
              </div>
              <div className="w-full h-px bg-border-color dark:bg-stone-700 my-1"></div>
              <div className="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center gap-0.5">
                <div>
                  <p className="text-text-muted text-xs font-semibold uppercase tracking-wider mb-0">
                    Order Number
                  </p>
                  <p className="text-text-main dark:text-white text-base font-bold font-mono mt-2">
                    #{orderData?.saleOrderNo || orderData?.ROWID || orderId}
                  </p>
                </div>
                <div className="flex gap-2 w-full sm:w-auto">
                  <p className="text-text-muted text-xs">
                    Ordered on: {formatDate(orderData?.orderDate)}
                  </p>
                </div>
              </div>
              {amount && (
                <div className="mt-2">
                  <p className="text-text-muted text-xs">
                    Total Amount: <span className="font-bold text-green-600">₹{parseFloat(amount).toFixed(2)}</span>
                  </p>
                </div>
              )}
            </div>

            {/* Order Items List */}
            <div className="flex flex-col gap-3">
              <h2 className="text-xl font-bold text-text-main dark:text-white px-2">
                Items in Your Order ({orderItems.length})
              </h2>

              {orderItems.length === 0 ? (
                <p className="text-text-muted text-center py-8">No items found in this order.</p>
              ) : (
                orderItems.map((item, index) => {
                  const salesOrderItem = item.salesOrderItem;
                  const imageUrl = getShadeImage(salesOrderItem.shadeNo);
                  const shadeNumber = getShadeNumber(salesOrderItem.shadeNo);

                  console.log(`Item ${index} - Shade:`, salesOrderItem.shadeNo, "Image URL:", imageUrl);

                  return (
                    <div key={salesOrderItem.ROWID || index} className="flex flex-col sm:flex-row gap-4 p-4 bg-white dark:bg-surface-dark rounded-3xl border border-border-color dark:border-stone-700">
                      <div className="sm:w-32 aspect-square rounded-lg bg-gray-100 dark:bg-stone-800 overflow-hidden shrink-0 relative">
                        <img
                          src={imageUrl}
                          alt={`Shade ${shadeNumber}`}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            console.log("Image failed to load:", imageUrl);
                            e.target.src = "/fallback-image.jpg";
                          }}
                          onLoad={() => console.log("Image loaded successfully:", imageUrl)}
                        />
                      </div>
                      <div className="flex-1 flex flex-col justify-between">
                        <div>
                          <div className="flex justify-between items-start">
                            <h3 className="font-bold text-lg text-forest-green dark:text-primary">
                              {getProductDescription(salesOrderItem.productDescription)}
                            </h3>
                            <span className="font-semibold text-text-main dark:text-white">
                              ₹{parseFloat(salesOrderItem.totalAmount).toFixed(2)}
                            </span>
                          </div>
                          <p className="text-sm text-text-muted mt-1">
                            Shade #{shadeNumber} • Quantity: {salesOrderItem.qty}
                          </p>
                        </div>
                        <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm border-t border-border-color dark:border-stone-700 pt-3">
                          <div>
                            <span className="text-text-muted block text-xs">
                              Dimensions
                            </span>
                            <span className="font-medium dark:text-gray-300">
                              W: {salesOrderItem.width} | D: {salesOrderItem.dropValue}
                            </span>
                          </div>
                          <div>
                            <span className="text-text-muted block text-xs">
                              Area
                            </span>
                            <span className="font-medium dark:text-gray-300">
                              {salesOrderItem.area} sq.ft
                            </span>
                          </div>
                          <div>
                            <span className="text-text-muted block text-xs">
                              Color
                            </span>
                            <span className="font-medium dark:text-gray-300">
                              {getMechanismColorName(salesOrderItem.mechanismColour)}
                            </span>
                          </div>
                          <div>
                            <span className="text-text-muted block text-xs">
                              Rate
                            </span>
                            <span className="font-medium dark:text-gray-300">
                              ₹{salesOrderItem.rate}
                            </span>
                          </div>
                          {salesOrderItem.motorType && salesOrderItem.motorType !== "N/A" && (
                            <div className="col-span-2">
                              <span className="text-text-muted block text-xs">
                                Motorization
                              </span>
                              <span className="font-medium dark:text-gray-300 flex items-center gap-1">
                                <CloudLightning size={16} />
                                {getMotorName(salesOrderItem.motorType)}
                              </span>
                            </div>
                          )}
                          {salesOrderItem.operations && (
                            <div>
                              <span className="text-text-muted block text-xs">
                                Operation Side
                              </span>
                              <span className="font-medium dark:text-gray-300">
                                {salesOrderItem.operations}
                              </span>
                            </div>
                          )}
                          {salesOrderItem.hsnCode && (
                            <div>
                              <span className="text-text-muted block text-xs">
                                HSN Code
                              </span>
                              <span className="font-medium dark:text-gray-300">
                                {salesOrderItem.hsnCode}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>

          {/* Right Column: Summary & Actions */}
          <div className="lg:col-span-5 flex flex-col gap-6">
            {/* Shipping Address Card */}
            <div className="bg-white dark:bg-surface-dark p-4 rounded-3xl border border-border-color dark:border-stone-700">
              <div className="flex gap-3 items-start">
                <div className="p-2 bg-background-light dark:bg-stone-800 rounded-lg">
                  <MapPin size={20} className="text-forest-green dark:text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-text-main dark:text-white text-sm mb-2">
                    Shipping Address
                  </h3>
                  {selectedAddress ? (
                    <div className="text-text-muted text-sm space-y-1">
                      <p className="font-medium text-text-main dark:text-white">
                        {selectedAddress.name}
                      </p>
                      <p>{selectedAddress.address}</p>
                      {selectedAddress.apartment && <p>Apt: {selectedAddress.apartment}</p>}
                      <p>
                        {selectedAddress.city}, {selectedAddress.state} - {selectedAddress.postalCode}
                      </p>
                      <p>{selectedAddress.country}</p>
                      {selectedAddress.company && (
                        <p className="text-xs">Company: {selectedAddress.company}</p>
                      )}
                      <p className="flex items-center gap-1 mt-2 text-xs">
                        <span className="font-medium">Phone:</span> {selectedAddress.phone}
                      </p>
                    </div>
                  ) : (
                    <p className="text-text-muted text-sm">Address will be updated soon</p>
                  )}
                </div>
              </div>
            </div>

            {/* Payment Method */}
            <div className="bg-white dark:bg-surface-dark p-4 rounded-3xl border border-border-color dark:border-stone-700">
              <div className="flex gap-3 items-start">
                <div className="p-2 bg-background-light dark:bg-stone-800 rounded-lg">
                  <CreditCard size={20} className="text-forest-green dark:text-primary" />
                </div>
                <div>
                  <h3 className="font-bold text-text-main dark:text-white text-sm mb-1">
                    Payment Method
                  </h3>
                  <p className="text-text-muted text-sm">
                    {paymentMethod}
                  </p>
                </div>
              </div>
            </div>

            {/* Cost Summary */}
            <div className="bg-white dark:bg-surface-dark p-5 rounded-3xl border border-border-color dark:border-stone-700">
              <h3 className="font-bold text-lg mb-4 text-text-main dark:text-white">
                Summary
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between text-sm text-text-muted">
                  <span>Subtotal</span>
                  <span className="font-medium text-text-main dark:text-gray-300">
                    ₹{parseFloat(orderData?.subTotal || 0).toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between text-sm text-text-muted">
                  <span>Shipping</span>
                  <span className="font-medium text-text-main dark:text-gray-300">
                    ₹{parseFloat(orderData?.shippingCharges || 0).toFixed(2)}
                  </span>
                </div>
                {orderData?.cgst && parseFloat(orderData.cgst) > 0 && (
                  <div className="flex justify-between text-sm text-text-muted">
                    <span>CGST</span>
                    <span className="font-medium text-text-main dark:text-gray-300">
                      ₹{parseFloat(orderData.cgst).toFixed(2)}
                    </span>
                  </div>
                )}
                {orderData?.sgst && parseFloat(orderData.sgst) > 0 && (
                  <div className="flex justify-between text-sm text-text-muted">
                    <span>SGST</span>
                    <span className="font-medium text-text-main dark:text-gray-300">
                      ₹{parseFloat(orderData.sgst).toFixed(2)}
                    </span>
                  </div>
                )}
                {orderData?.igst && parseFloat(orderData.igst) > 0 && (
                  <div className="flex justify-between text-sm text-text-muted">
                    <span>IGST</span>
                    <span className="font-medium text-text-main dark:text-gray-300">
                      ₹{parseFloat(orderData.igst).toFixed(2)}
                    </span>
                  </div>
                )}
                <div className="h-px bg-border-color dark:bg-stone-700 my-2"></div>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-text-main dark:text-white">
                    Total
                  </span>
                  <span className="font-bold text-xl text-forest-green dark:text-primary">
                    ₹{parseFloat(orderData?.total || amount || 0).toFixed(2)}
                  </span>
                </div>
              </div>
              <button
                className="w-full mt-6 h-12 border border-border-color dark:border-stone-600 rounded-xl text-text-main dark:text-gray-300 text-sm font-semibold hover:bg-background-light dark:hover:bg-stone-800 flex items-center justify-center gap-2 transition-colors"
                onClick={() => window.print()}
              >
                <ReceiptText size={18} />
                Print Receipt
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Action */}
        <div className="mt-12 flex flex-col items-center justify-center py-8">
          <button
            className="group h-12 px-8 rounded-full bg-green-600 text-white font-bold shadow-lg hover:scale-105 transition-transform flex items-center gap-2"
            onClick={() => navigate('/shop')}
          >
            Continue Shopping
            <MoveRight className="-mb-2" />
          </button>
        </div>
      </main>
    </div>
  );
};

export default OrderConfirmation;

